import React from "react";
import Typography from "@material-ui/core/Typography";
import {tagResources} from "../endpoints";
import TablaTagsFactor from "../components/TablaTagsFactor";
import TablaTagSinFactor from "../components/TablaTagSinFactor";

class DetalleEliminados extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            factor:false,
            sin_factor:false,
            tag: props.match.params.tag,
            value:"desagrupado"
        }
    }


    obtenerTipoCampos = () =>{
        tagResources.obtenerTipoCampos().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result === "con_factor"){
                this.setState({factor: true})
            }
            else{
                this.setState({sin_factor:true})
            }
        }).catch(error=> {
            console.log(error)
        });
    }


    handleChangeLoading = () =>{
        //NO BORRAR
    }

    componentDidMount() {
        this.obtenerTipoCampos()
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Detalle eliminados tag: {this.state.tag}
                </Typography>
                { this.state.factor && <TablaTagsFactor origen={"eliminados"} mandatorio={null} tag={this.state.tag} tipo={this.state.value} handleLoading={this.handleChangeLoading}/>}
                { this.state.sin_factor && <TablaTagSinFactor origen={"eliminados"} mandatorio={null} tag={this.state.tag} tipo={this.state.value} handleLoading={this.handleChangeLoading}/>}
            </div>
        )
    }
}
export default DetalleEliminados;